import { styled } from 'theme'

export const StyledUserEditForm = styled.div`
  background-color: white;
  max-width: 700px;
  margin: 0 auto;
`

export const StyledTitle = styled.div`
  padding: 1rem;
  font-size: 18px;
  font-weight: bold;
`
